import * as React from 'react';
import classnames from "classnames";

import { EditCreatePersonStoreState } from "./EditCreatePersonStore";
import { EditCreatePersonActions } from "./EditCreatePersonActions";
import { IForm } from "../IForm";
import { DivisionSelector } from "../../DivisionSelector";
import { Polyglot } from '../../../../polyglot';
import { InputTextGroup, CheckboxGroup, LoadableGroup } from "../../Forms/Groups";

const styles = require('./EditCreatePerson.scss');

interface FormProps
{
    polyglot: Polyglot;
    loadingDivisions: boolean;
}

// Partial because these props will be injected
type Props = Partial<EditCreatePersonStoreState> & Partial<EditCreatePersonActions> & FormProps;

export class EditCreatePerson extends React.Component<Props> implements IForm
{
    render()
    {
        const {
            draft,
            setFirstName, setLastName, setUserName, setAdminFlag,
            setPassword, setPasswordConfirmation,
            polyglot,
        } = this.props;
        return (
            <div className={classnames("form-horizontal", styles.EditCreatePerson)}>
                <InputTextGroup readOnly title={polyglot.t('person.label_division') + ':'} value={draft.DivisionReg} />
                <InputTextGroup readOnly title={polyglot.t('person.label_first_name') + ':'} value={draft.Firstname} onChange={e => setFirstName(e.target.value)} />
                <InputTextGroup readOnly title={polyglot.t('person.label_last_name') + ':'} value={draft.Lastname} onChange={e => setLastName(e.target.value)} />
                <InputTextGroup readOnly title={polyglot.t('person.label_username') + ':'} value={draft.Username} onChange={e => setUserName(e.target.value)} />
                <CheckboxGroup readOnly title={polyglot.t('person.label_is_administrator')} checked={draft.IsAdministrator} onChange={e => setAdminFlag(e.target.checked)} disabled={true} />
            </div>
        );
    }

    getValue()
    {
        return {...this.props.draft};
    }
}


// WEBPACK FOOTER //
// ./src/app/components/Pages/Person/EditCreatePerson.tsx